import {
	calculateModuleUsageFact,
	previewPayment,
} from '../../../slices/payment/thunk';

export const previewErrorDetail = error => {
	if (error == null || error === '') {
		return null;
	}
	if (typeof error === 'string') {
		return error;
	}
	if (typeof error.detail === 'string' && error.detail) {
		return error.detail;
	}
	if (typeof error.message === 'string' && error.message) {
		return error.message;
	}
	return null;
};

const emptyResult = () => ({
	previewErrorDetail: null,
	smaPreview: null,
	refreshErrorDetail: null,
});

export const runFactsCalculatePreview = async ({
	dispatch,
	previewPaymentApi,
	refreshFacts,
	year,
	month,
	includeSma,
}) => {
	if (year === '' || month === '' || year == null || month == null) {
		return emptyResult();
	}

	try {
		await dispatch(calculateModuleUsageFact({ year, month })).unwrap();
	} catch (error) {
		return {
			previewErrorDetail: previewErrorDetail(error),
			smaPreview: null,
			refreshErrorDetail: null,
		};
	}

	let refreshErrorDetail = null;
	try {
		await refreshFacts({ year, month, limit: 9999 });
	} catch (error) {
		refreshErrorDetail =
			previewErrorDetail(error) ||
			'No se pudieron recargar los hechos guardados.';
	}

	try {
		await dispatch(
			previewPayment({ year, month, category: 'REGULAR' })
		).unwrap();
	} catch (error) {
		return {
			previewErrorDetail: previewErrorDetail(error),
			smaPreview: null,
			refreshErrorDetail,
		};
	}

	let smaPreview = null;
	if (includeSma && previewPaymentApi) {
		smaPreview = await previewPaymentApi({
			year: year,
			month: month,
			category: 'SMA',
		});
	}

	return {
		previewErrorDetail: null,
		smaPreview,
		refreshErrorDetail,
	};
};
